import { composeReducers } from 'common/util/composeReducers';
import * as A from 'common/actions/login';
import lodash from 'lodash';

export function gettingMe(state, action) {
    if (!action || action.type !== A.GET_ME_START) {
        return state;
    }
    return {
        ...state,
        app: {
            ...state.app,
            loadingMe: true,
        }
    };
}

export function setMe(state, action) {
    if (!action || action.type !== A.GET_ME_COMPLETE) {
        return state;
    }

    const me = lodash.get(action, 'payload.data.me', null);

    if (!me) {
        return {
            ...state,
            app: {
                ...state.app,
                loadingMe: false
            }
        };
    }

    me.systemPermissions = me.systemPermissions ? JSON.parse(me.systemPermissions) : {};
    me.institutionPermissions = me.institutionPermissions ? JSON.parse(me.institutionPermissions) : {};
    me.binderPermissions = me.binderPermissions ? JSON.parse(me.binderPermissions) : {};
    me.featureAccess = me.featureAccess ? groupFeatureAccessByEntity(me.featureAccess) : {};
    me.monitorFeatureAccess = me.monitorFeatureAccess ? groupFeatureAccessByEntity(me.monitorFeatureAccess) : {};
    lodash.forEach(me.documentTypes, dt => dt.permissions = dt.permissions ? JSON.parse(dt.permissions) : {});
    me.documentTypes = lodash.keyBy(me.documentTypes, 'id');
    me.institution.properties = me.institution.properties ? lodash.keyBy(me.institution.properties, 'type') : {};

    return {
        ...state,
        app: {
            ...state.app,
            loadingMe: false
        },
        me
    };
}

function groupFeatureAccessByEntity(featureAccess) {
    return featureAccess.reduce((acc, entityFeatureAccess) => {
        const features = mapFeatureAccessToObject(entityFeatureAccess.features);
        acc[entityFeatureAccess.entityKey] = features;
        return acc;
    }, {});
}

function mapFeatureAccessToObject(features) {
    const reducedFeatures = features.reduce(
        (acc, { featureKey, subscribed }) => Object.assign({}, acc, { [featureKey]: subscribed }), {});
    return reducedFeatures;
}

export function setloginStatus(state, action) {
    if (!action || action.type !== A.LOGIN_COMPLETE) {
        return state;
    }

    return {
        ...state,
        app: {
            ...state.app,
            loginStatus: true,
        }
    };
}

export function clearLoginStatus(state, action) {
    if (!action || action.type !== A.CLEAR_LOGIN_STATUS) {
        return state;
    }

    return {
        ...state,
        app: {
            ...state.app,
            loginStatus: false,
        }
    };
}

export function updateMe(state, action) {
    if (!action || action.type !== A.UPDATE_ME) {
        return state;
    }
    return {
        ...state,
        me: {
            ...state.me,
            ...action.payload
        }
    };
}

export function removeMe(state, action) {
    if (!action || action.type !== A.REMOVE_ME) {
        return state;
    }

    const newState = {
        ...state,
        app: {
            ...state.app,
            loadingMe: false
        },
        me: {}
    };

    return newState;
}

export function meError(state, action) {
    if (!action || action.type !== A.GET_ME_ERROR) {
        return state;
    }

    return {
        ...state,
    };
}

export function reloading(state, action) {
    if (!action || action.type !== A.SET_RELOADING) {
        return state;
    }

    return {
        ...state,
        reloading: action.payload
    };
}

export function loginEmailError(state, action) {
    if (!action || action.type !== A.LOGIN_EMAIL_ERROR) {
        return state;
    }
    return {
        ...state,
        loginEmailError: action.errors
    };
}

export function loginError(state, action) {
    if (!action || action.type !== A.LOGIN_ERROR) {
        return state;
    }

    return {
        ...state,
        loginError: action.errors
    };
}

export function loginShowPassword(state, action) {
    if (!action || action.type !== A.SHOW_PASSWORD) {
        return state;
    }

    return {
        ...state,
        showPassword: action.payload
    };
}

export function loginShowExpiredPassword(state, action) {
    if (!action || action.type !== A.SHOW_EXPIRED_PASSWORD) {
        return state;
    }

    return {
        ...state,
        showExpiredPassword: action.payload
    };
}

export function setPasswordResetEmailSent(state, action) {
    if (!action || action.type !== A.SHOW_PASSWORD_RESET_EMAIL_SENT_SCREEN) {
        return state;
    }

    return {
        ...state,
        showPasswordResetEmailSentScreen: action.payload
    };
}

export function loginStart(state, action) {
    if (!action || action.type !== A.SHOW_PASSWORD) {
        return state;
    }

    return {
        ...state,
        loginError: '',
        loginEmailError: ''
    };
}
export function resetPasswordAnswerError(state, action) {
    if (!action || action.type !== A.RESET_PASSWORD_ANSWER_ERROR) {
        return state;
    }
    return {
        ...state,
        resetPasswordAnswerError: action.errors
    };
}

export function keymasterSigningError(state, action) {
    if (!action || action.type !== A.KEYMASTER_SIGNING_ERROR) {
        return state;
    }
    return {
        ...state,
        keymasterSigningError: action.errors
    };
}



export function resetPasswordValidationError(state, action) {
    if (!action || action.type !== A.RESET_PASSWORD_VALIDATION_ERROR) {
        return state;
    }
    return {
        ...state,
        resetPasswordValidationError: action.errors
    };
}

export function loginSetSessionId(state, action) {
    if (!action || action.type !== A.LOGIN_SET_SESSION) {
        return state;
    }

    return {
        ...state,
        loginSessionId: action.payload
    };
}
export default composeReducers(
    gettingMe,
    setMe,
    setloginStatus,
    clearLoginStatus,
    updateMe,
    removeMe,
    meError,
    reloading,
    loginEmailError,
    loginError,
    loginShowPassword,
    loginStart,
    resetPasswordAnswerError,
    keymasterSigningError,
    resetPasswordValidationError,
    loginSetSessionId,
    setPasswordResetEmailSent,
    loginShowExpiredPassword
);
